import {
  TEntityResponse,
  TEntityListResponse,
  TActionTypeResBody,
  TActionTypeSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TActionsClient = {
  get(id: string): Promise<TEntityResponse<'action-type', TActionTypeResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'action-type', TActionTypeSummaryResBody> | undefined>;
};

function ActionsClient(apiClient: TAPIClient): TActionsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'action-type', TActionTypeResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'action-type', TActionTypeResBody>>(`/action-types/${id}`);

      if (data && data.type !== 'action-type') {
        throw new Error('Invalid entity type received, expected: action-type, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'action-type', TActionTypeSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'action-type', TActionTypeSummaryResBody>>(
        `/action-types?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'action-type') {
        throw new Error('Invalid entity type received, expected: action-type, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TActionsClient, ActionsClient };
